import { Component, Input } from '@angular/core';

@Component({
  selector: 'fin-form-input-group',
  templateUrl: 'form-input-group.component.html',
})
export class FormInputGroupComponent {
  @Input()
  id: string;

  @Input()
  translationPrefix: string;

  @Input()
  required = false;

  constructor() {}
}
